type ValuesMap = {
  [key: string]: string;
};

const getValuesMap = (values: string[]): ValuesMap => {
  const map: ValuesMap = {};

  for (let i = 0; i < values.length; i++) {
    map[values[i]] = `${i + 1}`;
  }

  return map;
};

const buildLPS = (text: string[]) => {
  let left = 0;
  let right = 1;

  const lps: number[] = [0];

  while (right < text.length) {
    if (text[left] === text[right]) {
      left++;
      lps[right] = left;
      right++;
    } else if (left !== 0) {
      left = lps[left - 1];
    } else {
      lps[right] = 0;
      right++;
    }
  }

  return lps;
};

export const cycleDetection = (text: string[]) => {
  const uniqueValues = new Set(text);
  const map = getValuesMap([...uniqueValues]);
  const reversed = [...text].reverse().map((val) => map[val]);
  const lps = buildLPS(reversed);

  let zerosCount = 0;
  let maxValue = -1;

  for (let i = 0; i < reversed.length; i++) {
    if (lps[i] === 0 && maxValue <= 0) zerosCount++;
    if (lps[i] >= maxValue) maxValue = lps[i];
    else break;
  }

  const patternLength = zerosCount;

  let ones = 0;

  for(let i = 0; i < reversed.length; i++) {
    if(lps[i] === 0) continue;
    if(lps[i] === 1) ones++;
    if(lps[i] > 1) break;
  }

  const offset = Math.floor(ones / 2)

  const decodedPattern = [...reversed.slice(0, zerosCount + offset)]
    .reverse()
    .map((value) => {
      const entry = Object.entries(map).find(([_, mapped]) => mapped === value);

      return entry ? entry[0] : '';
    });

  return {
    cycle: decodedPattern,
    occurences: maxValue ? Math.ceil((maxValue + 1) / patternLength) : 1,
  };
};
